import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData } from '../../services/webinarQaServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { isQuillContentEmpty } from '../../utils/common';
import ReactQuill from 'react-quill';

const Webinarqa = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '', webinarqa_order: '', title: '', description: '' });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [editingId, setEditingId] = useState(null)
  // Fetch data list
  const fetchData = useCallback(async () => {
    setLoading(true);
    try { 
    const data = await getData();
    setDataList(data);}
    catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }  
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

 
  const validateForm = () => {
  const newErrors = {};
  if (!form.webinarqa_order) newErrors.webinarqa_order = "Order is required";
  if (!form.title) newErrors.title = "Title is required";
  if ( isQuillContentEmpty(form.description.trim())) newErrors.description = "Description is required"; 
  if (form.webinarqa_order && isNaN(form.webinarqa_order)) newErrors.webinarqa_order = "Order must be a number";
  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
}
  const handleChange = (e) => {
    try{
    const { name, value } = e.target;
    let updatedErrors = { ...errors };
    if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
      }
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors(updatedErrors);
    const isValid = /^[0-9]*$/.test(value);
    if (name === "webinarqa_order") {
        if (value.trim() === '') {
          updatedErrors[name] = "Order is required";
        }
        else if (!isValid) {
            updatedErrors[name] = "Only numbers are allowed";
            setErrors(updatedErrors);
          }
        else if (Number(value) === 0) {
          updatedErrors[name] = "Order value must be greater than zero";
        } 
        else{
          const isDuplicate = dataList.some((item) => {
          if (item.id === editingId) return false; // skip comparing with self
          return  item?.webinarqa_order === Number(value);
          });
          if (isDuplicate) {
          updatedErrors[name] = "Order is already exists";
          } 
        } 
          setErrors(updatedErrors);
        }
      }
    catch (error) { 
      console.error('Error handling change:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {  
      return;
    }
    try{
      let response;
    if (modalType === 'add') {
       response =  await addData(form);
       if (response&&(response.status === 200 || response.status === 201)) {
       toast.success("Added successfully!", {
                        position: 'top-right',
                        autoClose: 3000,
                      });
                    }
      else{
        toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
        console.log((response?.message || "Failed to process request."));
      }
    } else if (modalType === 'edit') {
      response = await updateData(form);
        if (response&&(response.status === 200 || response.status === 201)) {
          toast.success("Update successfully!", {
                        position: 'top-right',autoClose: 3000,});
            }
        else{
        toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
        console.log((response?.message || "Failed to process request."));
        }
    }
    fetchData();  // Re-fetch data after adding/editing
    setShowModal(false);
  }
  catch (error) {
      console.error('Error submitting form:', error);  
    }
  };

  const handleDelete = async () => {
    try{
    if (selectedData) {
      // Optimistically remove the data from the list
      setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
      // Proceed with the actual delete request
      await deleteData(selectedData);
      setShowDeleteConfirmModal(false);
      toast.success("Deleted successfully!", {
                        position: 'top-right',autoClose: 3000,});
    }
  }
  catch (error) { 
      console.error('Error deleting data:', error);
    }
  };

  const openModal = (type, data = { id: '', webinarqa_order: '', title: '', description: '' }) => {
    setModalType(type);
    setEditingId(data?.id);
    setForm(data);
    setShowModal(true);
  };
  
  const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    const filtered = dataList.filter(
      (data) =>
      data.title.toLowerCase().includes(searchText.toLowerCase()) ||
      data.description.toLowerCase().includes(searchText.toLowerCase())
    );
    const sortedData = [...filtered].sort((a, b) => new Date(a.webinarqa_order) - new Date(b.webinarqa_order));
    return sortedData;
  }, [dataList, searchText]);

const modules = {
  toolbar: [
    // Font family and size
    [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

    // Headings
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    // Text styles
    ['bold', 'italic', 'underline', 'strike'],

    // Subscript / Superscript
    [{ 'script': 'sub' }, { 'script': 'super' }],

    // Blockquote and code block
    ['blockquote', 'code-block'],

    // Color and background
    [{ 'color': [] }, { 'background': [] }],

    // Text alignment and direction (RTL)
    [{ 'align': [] }, { 'direction': 'rtl' }],

    // Ordered / bullet list
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    // Indent and outdent
    [{ 'indent': '-1' }, { 'indent': '+1' }],

      ['link'],

    // Clear formatting
    ['clean']
  ]
};

const formats = [
  'font', 'size',
  'header',
  'bold', 'italic', 'underline', 'strike',
  'script',
  'blockquote', 'code-block',
  'color', 'background',
  'align', 'direction',
  'list', 'bullet', 'indent',
  'link', 'image', 'video'
];
  
// Handle change for Quill editor
  const handleDescriptionChange = (value) => {
    setErrors((prev) => ({ ...prev, description: isQuillContentEmpty(value) ? 'Description is required' : '' }));
    setForm((prev) => ({ ...prev, description: value }));
  };

  const columns = [

    {
      name: 'Order',
      selector: (row) => row.webinarqa_order,
      sortable: true,
      width: '30%', 
      wrap: true,  
      maxWidth: '100px',
    },
    {
      name: 'Title',
      selector: (row) => row.title,
      cell: (row) => (
            <span title={row.title}>
              {row.title}
            </span>
          ),
      sortable: true,
      width: '40%', 
      wrap: true,     
      // maxWidth: '170px',
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
          <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
        </div>
      ),
      // width: '160px', 
      wrap: true,     
      // maxWidth: '200px',
      width:"30"
    },
  ];

  useEffect(() => {
        const tooltipMap = {
          'ql-bold': 'Bold',
          'ql-italic': 'Italic',
          'ql-underline': 'Underline',
          'ql-strike': 'Strikethrough',
          'ql-script[value="sub"]': 'Subscript',
          'ql-script[value="super"]': 'Superscript',
          'ql-blockquote': 'Blockquote',
          'ql-code-block': 'Code Block',
          'ql-color': 'Text Color',
          'ql-background': 'Background Color',
          'ql-align': 'Align',
          'ql-direction': 'Text Direction',
          'ql-list[value="ordered"]': 'Ordered List',
          'ql-list[value="bullet"]': 'Bullet List',
          'ql-indent[value="-1"]': 'Outdent',
          'ql-indent[value="+1"]': 'Indent',
          'ql-link': 'Insert Link',
          'ql-clean': 'Clear Formatting',
        };
  
      const setTooltips = () => {
        Object.entries(tooltipMap).forEach(([selector, title]) => {
          const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
          if (el && !el.title) {
            el.setAttribute('title', title);
          }
        });
      };
  
      const observer = new MutationObserver((mutations, obs) => {
        const toolbarReady = document.querySelector('.ql-toolbar');
        if (toolbarReady) {
          setTooltips();
          obs.disconnect(); // Stop observing once done
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
  
    return () => observer.disconnect() // Clean up on unmount
    }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Event Pages / Webinar <b>/ Webinar QA</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" size='lg'>
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom'>Order <small className='text-danger form-label-note'> * </small></Form.Label>
                  <Form.Control type="text" name="webinarqa_order" value={form.webinarqa_order} onChange={handleChange} isInvalid={!!errors.webinarqa_order}/>
                  <Form.Control.Feedback type="invalid">{errors.webinarqa_order}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom'>Title <small className='text-danger form-label-note'> * </small></Form.Label>
                  <Form.Control type="text" name="title" value={form.title} onChange={handleChange}  isInvalid={!!errors.title}/>
                  <Form.Control.Feedback type="invalid">{errors.title}</Form.Control.Feedback>
                </Form.Group>
                {/* <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom'>Description <small className='text-danger form-label-note'> * </small></Form.Label>
                  <Form.Control as = 'textarea'  rows={8} name="description" value={form.description} onChange={handleChange}  isInvalid={!!errors.title}/>
                  <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
                </Form.Group> */}
              {/*  Description */}
                <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom'>Description <small className='text-danger form-label-note'> * </small></Form.Label>
                  <div className={`react-quill-editor`}>
                  <ReactQuill
                    value={form.description}
                    onChange={handleDescriptionChange}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    placeholder="Enter description"
                    className={`${errors.description ? 'border border border-1 border-danger rounded' : ''}`} 
                  />
                  {errors.description && (
                      <div className="invalid-feedback d-block">
                        {errors.description}
                      </div>
                    )}
                    </div>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer className='border-0'>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default Webinarqa;